import React from 'react';
import clsx from 'clsx';
import { createUseStyles } from 'react-jss';

export interface ITitleProps {
    children: React.ReactNode;
    className?: string;
}

const useStyles = createUseStyles({
    root: {
        fontFamily: 'var(--sans)',
    },
});

export const Title: React.FunctionComponent<ITitleProps> = props => {
    const styles = useStyles();
    return (
        <span className={clsx(styles.root, props.className)}>{props.children}</span>
    );
};
